var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"content__title"},[_c('h1',[_c('div',{class:['ini-icon','ini-icon--'+_vm.icon]}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }